import { Refresh } from '@mui/icons-material';
import { Box, Button, Container, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { Link } from 'react-router-dom';

export default function ErrorComponent({ errorType = 'RouteNotFound' }: { errorType?: 'RouteNotFound' | 'ErrorBoundary' }) {

	return (
		<Box
			sx={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				height: 'calc(100vh - 115px)',
			}}
		>
			<Container maxWidth="md">
				<Grid container spacing={2}>
					<Grid xs={12}>
						{errorType === 'RouteNotFound' ? (
							<>
								<Typography variant="h1">404</Typography>
								<Typography variant="h6">The page you’re looking for doesn’t exist.</Typography>
								<Link to="/">
									{' '}
									<Button variant="contained">Back Home</Button>
								</Link>
							</>
						) : (
							<>
								<Typography variant="h2">Something went wrong</Typography>
								<Typography variant="h6" mt={1}>Please try reloading the page.</Typography>
								<Button startIcon={<Refresh />} variant="contained" sx={{ mt: 1, borderRadius: '8px' }} onClick={() => window.location.reload()}>Reload</Button>
							</>
						)}
					</Grid>
				</Grid>
			</Container>
		</Box>
	);
}
